import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Component to add FAQ structured data to pages
 * This improves search engine rich results
 */
const FaqSchema = () => {
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is The Code-E Project?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Code-E Project is an educational resource website designed to help students learn frontend web development, including HTML, CSS, JavaScript, Bootstrap, and more. It features a clean black-and-white design with comprehensive guides and tutorials."
        }
      },
      {
        "@type": "Question",
        "name": "Is The Code-E Project free to use?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, The Code-E Project is completely free for students and anyone interested in learning web development. All tutorials, guides, and resources are available at no cost."
        }
      },
      {
        "@type": "Question",
        "name": "What programming languages are covered on The Code-E Project?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The Code-E Project currently covers HTML, CSS, JavaScript, Bootstrap, and MongoDB. It also provides resources for using VS Code as a development environment."
        }
      },
      {
        "@type": "Question",
        "name": "How can I contact The Code-E Project team?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can contact The Code-E Project team via email at support@thecodeeproject.com with any questions, feedback, or suggestions."
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(faqData)}
      </script>
    </Helmet>
  );
};

export default FaqSchema; 